import { BRAND } from "@neus/shared";
import { PHONE_HREF } from "../../nav";
import { FacebookIcon, InstagramIcon, PhoneIcon } from "../Icons";
import styles from "./Layout.module.css";

export function TopBar() {
  return (
    <div className={styles.topBar}>
      <div className={`container ${styles.topBarInner}`}>
        <div className={styles.social}>
          {BRAND.social.facebook && (
            <a href={BRAND.social.facebook} target="_blank" rel="noreferrer" aria-label={`${BRAND.name} on Facebook`}>
              <FacebookIcon alt="Facebook" />
            </a>
          )}
          {BRAND.social.instagram && (
            <a href={BRAND.social.instagram} target="_blank" rel="noreferrer" aria-label={`${BRAND.name} on Instagram`}>
              <InstagramIcon alt="Instagram" />
            </a>
          )}
        </div>
        <nav className={styles.sisterShops} aria-label="Our shops">
          {BRAND.shops.map((s) =>
            s.href.startsWith("http") ? (
              <a key={s.label} href={s.href} target="_blank" rel="noreferrer">
                {s.label}
              </a>
            ) : (
              <a key={s.label} href={s.href} aria-current="page">
                {s.label}
              </a>
            ),
          )}
        </nav>
        <a className={styles.phone} href={PHONE_HREF}>
          <PhoneIcon size={14} /> {BRAND.phone}
        </a>
      </div>
    </div>
  );
}
